<template>
    <v-container class="content-wrapper">
        <v-row column justify-center align-center>
            <!-- <v-col cols="12">
                <pre>{{ page }}</pre>
            </v-col> -->
            <v-col
                cols="12"
                :md="showSidebar ? 7 : 12"
                :lg="showSidebar ? 8 : 12"
            >
                <v-container
                    class="posts-wrapper pa-0"
                >
                    <v-row
                        v-if="posts && posts.length > 0"
                        column
                        justify-center
                        align-center
                        :class="{ 'featured-wrapper': true, posts: true }"
                    >
                        <v-col
                            v-for="(post, i) in posts"
                            :key="`post${i}`"
                            cols="12"
                            xs="12"
                            sm="6"
                            md="12"
                            lg="6"
                            xl="6"
                            :class="{
                                featured: post.isFeatured,
                                withSidebar: showSidebar
                            }"
                        >
                            <v-lazy
                                :options="{
                                    threshold: 0.8
                                }"
                                transition="fade-transition"
                            >
                                <CardSinglePost
                                    :post="post"
                                    :img-crop="setCrop()"
                                />
                            </v-lazy>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
            <v-col v-if="showSidebar && $vuetify.breakpoint.mdAndUp" cols="12" md="5" lg="4">
                <PostsSidebar :page="page" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import postUtilities from '~/mixins/postUtilities'
import CardSinglePost from '~/components/cards/CardSinglePost.vue'
import PostsSidebar from '~/components/PostsSidebar.vue'
// import EmbedCloudinary from '~/components/embeds/EmbedCloudinary.vue'

export default {
    name: 'PostsLayout',
    components: {
        // EmbedCloudinary,
        PostsSidebar,
        CardSinglePost
    },
    mixins: [postUtilities],
    data: () => ({
        showMore: 10,
        loadMore: true,
        busy: false,
        isMoreAvailable: true,
        isActive: false
    }),
    methods: {
        shouldSqueeze(str) {
            return str.length < 20 || false
        },
        fallbackImageId(thumb, fallback) {
            return thumb && thumb.imageId && thumb.imageDir
                ? thumb.imageId
                : fallback
        },
        fallbackImageDir(thumb, fallback) {
            return thumb && thumb.imageId && thumb.imageDir
                ? thumb.imageDir
                : fallback
        },
        fallbackImageAlt(thumb) {
            return thumb && thumb.alt
                ? thumb.alt
                : { en: 'c3controls', es: 'c3controls' }
        }
    }
}
</script>
